// Карточки комплексов
export function complexSlider() {
    var sliders = $('.complex-list__gallery-wrapp:not(.initialised)');

    sliders.each(function (index, el) {
        initComplexSlider($(el).find('.complex-list__gallery'), $(el).find('.complex-list__gallery-counter'));
        $(el).addClass('initialised')
    });

    function initComplexSlider(slider, sliderCount) {

        // фикс кривого свайпа на ios
        var tapArea = slider,
            startX;
        startX = 0;
        for (var item of tapArea) {
            item.ontouchstart = function (e) {
                startX = e.touches[0].clientX;
            };
            item.ontouchmove = function (e) {
                if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
                    e.preventDefault();
                }
            };
        }

        var complexSlider = $(slider).flickity({
            pageDots: false,
            cellAlign: 'center',
            contain: true,
            wrapAround: true,
            arrowShape: {
                x0: 30,
                x1: 60, y1: 30,
                x2: 65, y2: 25,
                x3: 40
            }
        });

        var complexSliderData = complexSlider.data('flickity');

        $(complexSlider).parent().next().find('.complex-list__video-play').on('click', function () {
            // Выбрать последний слайдер при клике на кнопку play
            complexSliderData.select(complexSliderData.slides.length - 1);
        });

        complexSliderData.on('change', function () {
            var slideNumber = this.selectedIndex + 1;
            let video = $(this.selectedElement).find('video');
            if (video.length) {
                video[0].play();
            }

            if (slideNumber === this.slides.length) {
                $(this.element).parent().next().addClass('complex-list__buttons-mob-center')
            } else {
                $(this.element).parent().next().removeClass('complex-list__buttons-mob-center')
            }
        })

        updateComplexSlider();
        complexSliderData.on('change', updateComplexSlider);

        function updateComplexSlider() {
            var slideNumber = complexSliderData.selectedIndex + 1;
            sliderCount.text(slideNumber + '/' + complexSliderData.cells.length);
        }
    }
}

export function showComplexSlider() {
    $(document).on('click', '.complex-more', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var wrapper = $(this).closest('.complex-list__right');
        var slider = wrapper.find('.complex-list__gallery-wrapp');
        var gallery = wrapper.find('.complex-list__gallery');
        var items = gallery.find('.complex-list__gallery-item');
        var grid = wrapper.find('.complex-list__images');
        items.addClass('fast_background_animate')
        items.addClass('fb_ev_img_load')
        items.addClass('fast_background')
        grid.removeClass('show');
        slider.removeClass('hidden');
        grid.addClass('hidden');
        grid.addClass('transparent');
        slider.addClass('show');
        fast_background.update();
    });

    $(document).on('click', '.complex-list__images-item:not(.complex-list__images-item-video)', function () {
        let block = $(this).parents('.complex-list__right');
        block.find('.complex-more').click();
        block.find('.complex-list__gallery').data('flickity').select($(this).data('index'));
    });

    $(document).on('click', '.complex-list__gallery-close', function (event) {
        var slider = $(this).closest('.complex-list__gallery-wrapp');
        var grid = $(this).closest('.complex-list__right').find('.complex-list__images');
        slider.addClass('hidden');
        grid.addClass('show');
        slider.removeClass('show');
        grid.removeClass('hidden');
        setTimeout(function () {
            grid.removeClass('transparent show');
        }, 1000);
    });
}

// FAQ
export function complexFaq() {
    $(document).on('click', '.complex-faq__question', function (){
        var faqItem = $(this).closest('.complex-faq__item');

        if ($(faqItem).hasClass('active')) {
            faqItem.removeClass('active');
            faqItem.find('.complex-faq__answer').slideUp(300);
            return false;
        }

        faqItem.toggleClass('active');
        faqItem.find('.complex-faq__answer').slideToggle(300);
    })
}

export function complexFilterSpecificSlide() {
    var btnFilterSpecificSlide = $('.btn-filter_specific_slide');
    btnFilterSpecificSlide.click(function(e) {
        e.preventDefault();
        var btn = $(this)
        var slideNumber = btn.data('slide');
        var slide = btn.closest('.complexes__slide')
        var slideSpecific = $('.complexes__slide[data-filter-slide="' + slideNumber + '"]')

        // Если следующий слайд будет дальше, то применяем стили слева направо
        if (parseInt(slideNumber) > parseInt(slide.data('filter-slide')))
        {
            slide.css('transform', "translateX(-100vw)")
            slideSpecific.css('transform', "translateX(0%)")
        }
        // Если предыдущий, то справа налево
        else
        {
            slideSpecific.css('transform', "translateX(0%)")
            slide.css('transform', "translateX(100vw)")
        }
    })
}

// кнопка "Где хотите жить?"
export function locationSearch() {
    var locationBtn = $('input[name="search-location"]'),
        dropDown = $('.filter__drop'),
        placeholder,
        placeholderActive,
        filterTags = $('.filter__search-tags'),
        filterMetroSelect = $('#filter_metro_select'),
        filterDistrictsSelect = $('#filter_districts_select'),
        metroList = $('#metro_list'),
        districtList = $('#district_list'),
        oneFilterDropDown = dropDown.filter('.filter__drop_one-filter');

    $(filterMetroSelect).on('click', function() {
        filterTags.hide();
        districtList.hide();
        metroList.show();
    });

    $(filterDistrictsSelect).on('click', function() {
        filterTags.hide();
        metroList.hide();
        districtList.show();
    });

    locationBtn.on('click', function(event) {
        placeholder = $(this).attr('placeholder');
        placeholderActive = $(this).data('active');
        $(this).attr('placeholder', placeholderActive)
    });

    $(document).on('click', function(event) {
        if (event.target.closest('input[name="search-location"]')) return;
        if (!event.target.closest('.drop-body')) {
            $(locationBtn).attr('placeholder', placeholder)
        }
    });

    let suggestTimeout;
    oneFilterDropDown.find('label:not([data-ignore-filter])').click(function() {
        var item = $(this);
        locationBtn.val(item.find('.filter__drop-item__title').text())
        if (oneFilterDropDown.attr('data-redirect-now')) {
            setTimeout(function() {
                // mainPageSendFilters();
            }, 300)
        }
    })

    locationBtn.on('input', function() {
        clearTimeout(suggestTimeout);
        let _this = $(this),
            url = _this.data('search-url'),
            query = _this.val(),
            metrosDrop = $('.filter__location-drop-metros'),
            complexesDrop = $('.filter__location-drop-complexes'),
            districtsDrop = $('.filter__location-drop-districts'),
            locationsDrop = $('.filter__location-drop-locations');

        if (gInitialData.domainConfig.has_regions) {
            var regionsDrop = $('.filter__location-drop-regions');
        }

        metroList.hide();
        districtList.hide();
        metrosDrop.hide();
        complexesDrop.hide();
        districtsDrop.hide();
        if (gInitialData.domainConfig.has_regions) {
            regionsDrop.hide();
        }
        locationsDrop.hide();

        if (query.length > 0) {

            suggestTimeout = setTimeout(function() {
                $.ajax({
                    url: url,
                    method: 'get',
                    data: {
                        query: query
                    },
                    success: function(json) {
                        var items = '';
                        var filter = '';
                        var item = '';
                        var tagsInputs = $('.first-screen__btn-item .filter__search-tags input');
                        tagsInputs.each(function(index, el) {
                            var input = $(el);
                            if (input.prop('checked') === true) {
                                input.prop('checked', false)
                                input.change();
                            }
                        })
                        filterTags.hide()
                        if (json.metros.length || (Object.prototype.toString.call(json.metros) === '[object Object]')) {
                            items = '';
                            filter = 'metro_id/int_multiple_filter';
                            if (json.metros.length) {
                                for (var i = 0; i < json.metros.length; i++) {
                                    item = json.metros[i];
                                    items += itemHTML(item, filter, 'Metro')
                                }
                            } else {
                                item = json.metros;
                                items += itemHTML(item, filter, 'Metro')
                            }
                            metrosDrop.find('ul').html(items);
                            metrosDrop.show();
                        }

                        if (json.complexes.length || (Object.prototype.toString.call(json.complexes) === '[object Object]')) {
                            var filterName = gInitialData.pageKey === 'lots' ? 'complex_id/int_multiple_filter' : 'id/int_multiple_filter';
                            items = '';
                            filter = filterName;
                            var link = gInitialData.pageKey === 'lots' ? 'undefined' :complexesDrop.data('url');
                            if (json.complexes.length) {
                                for (var i = 0; i < json.complexes.length; i++) {
                                    item = json.complexes[i];
                                    items += itemHTML(item, filter, 'Complex', link)
                                }
                            } else {
                                item = json.complexes;
                                items += itemHTML(item, filter, 'Complex', link)
                            }
                            complexesDrop.find('ul').html(items);
                            complexesDrop.show();
                        }

                        if (json.locations.length || (Object.prototype.toString.call(json.locations) === '[object Object]')) {
                            items = '';
                            filter = 'complex_location/int_multiple_filter';
                            if (json.locations.length) {
                                for (var i = 0; i < json.locations.length; i++) {
                                    item = json.locations[i];
                                    items += itemHTML(item, filter)
                                }
                            } else {
                                item = json.locations;
                                items += itemHTML(item, filter)
                            }
                            locationsDrop.find('ul').html(items);
                            locationsDrop.show();
                        }

                        if (json.districts.length || (Object.prototype.toString.call(json.districts) === '[object Object]')) {
                            items = '';
                            filter = 'district_id/int_multiple_filter';
                            if (json.districts.length) {
                                for (var i = 0; i < json.districts.length; i++) {
                                    item = json.districts[i];
                                    items += itemHTML(item, filter)
                                }
                            } else {
                                item = json.districts;
                                items += itemHTML(item, filter)
                            }
                            districtsDrop.find('ul').html(items);
                            districtsDrop.show();
                        }
                        if (gInitialData.domainConfig.has_regions) {
                            if (json.regions.length || (Object.prototype.toString.call(json.regions) === '[object Object]')) {
                                items = '';
                                filter = 'region_id/int_multiple_filter';
                                if (json.regions.length) {
                                    for (var i = 0; i < json.regions.length; i++) {
                                        item = json.regions[i];
                                        items += itemHTML(item, filter)

                                    }
                                } else {
                                    item = json.regions;
                                    items += itemHTML(item, filter)
                                }
                                regionsDrop.find('ul').html(items);
                                regionsDrop.show();
                            }

                        }

                        oneFilterDropDown.find('a').click(function() {
                            var item = $(this);
                            locationBtn.val(item.find('.filter__drop-item__title').text())
                            if (oneFilterDropDown.attr('data-redirect-now')) {
                                setTimeout(function() {
                                    mainPageSendFilters();
                                }, 300)
                            }
                        })

                        dropDown.find('[data-create-filter]').each(function(index, element) {
                            var item = $(element);
                            var inDynamic = checkInDynamicFilters(item);
                            if (inDynamic) {
                                item.parent().addClass('in_filter');
                            } else {
                                item.parent().removeClass('in_filter');
                            }
                        })
                        dropDown.find('[data-create-filter]').click(function() {
                            dropDown.find('[data-create-filter]').each(function(index, element) {
                                var item = $(element);
                                setTimeout(function() {
                                    var inDynamic = checkInDynamicFilters(item);
                                    if (inDynamic) {
                                        item.parent().addClass('in_filter');
                                    } else {
                                        item.parent().removeClass('in_filter');
                                    }
                                }, 200)
                            })
                        })
                    }
                });
            }, 350);
        } else {
            filterTags.show()
        }
    });
    const checkInDynamicFilters = (item) => {
        return !!$('#created-dynamic-filters').find('input[value="' + item.data('value') + '"][name="' + item.data('create-filter') + '"]').length;
    }
    const mainPageSendFilters = () => {
        $('#index-search').click();
        setTimeout(function() {
            clearDynamicFilters();
            clearFilterTags();
        }, 1000)
    }

    const clearDynamicFilters = () => {
        $('#created-dynamic-filters').empty();
    }
    const clearFilterTags = () => {
        $('.filter__search-tags').each(function(index, item) {
            var item = $(item);
            item.find('input').prop('checked', false);
        })
    }

    const itemHTML = (item, filter, type = '', link = '') => {
        var html = ''
        html += `<li class="filter__drop-item-wrapper">`
        if (type === 'Complex' && item.has_page && link !== 'undefined')
            html += `<a href="${link + '/' + item.slug}" target="_blank" class="filter__drop-item-link" data-create-filter="${filter}" data-value="${item.id}">`
        else if (type === 'Complex' && !item.has_page)
            html += `<a href="#" class="filter__drop-item-link" data-create-filter="complex_${filter}" data-value="${item.id}">`
        else
            html += `<a href="#" class="filter__drop-item-link" data-create-filter="${filter}" data-value="${item.id}">`
        html += `<div class="filter__drop-item">`
        if (type === 'Complex') {
            html += `<span class="metro-icon"><span class="filter__drop-dot"></span></span>`
        } else if (type === 'Metro') {
            var metroIconFilled = $('#metro-icon-example').html();
            if (gInitialData.domainConfig.icons.metro.fill) {
                metroIconFilled = metroIconFilled.split('{fill}')
                    .join(item.color);
            }
            html += `<span class="metro-icon">${metroIconFilled}</span>`
        } else {
            var bg = '';
            if (item.s_icon) {
                bg = `style="background-image: url('${item.s_icon}')"`
            }
            html += `<span class="herb-icon" ${bg}></span>`
        }

        html += `<label class="filter__drop-item__title">${item.title}</label>`
        html += `</div>`;
        html += `</a>`;
        html += `</li>`;
        return html;
    }
}

export function firstScreenBtn() {
    $('.first-screen__btn-item').on('click', function(event) {
        let generateBtnInputValue = function(el) {
            setTimeout(function() {
                let thisDropdown = el.closest('.first-screen__btn-item');
                let thisInput = thisDropdown.find('.first-screen__btn-input');
                let textArr = [];
                thisDropdown.find('label').each(function() {
                    let labelFor = $(this).attr('for');
                    if (labelFor !== undefined) {
                        let input = $('#' + labelFor);
                        if (input.is('[type=checkbox]') || input.is('[type=radio]')) {
                            if (input.is(':checked')) {
                                textArr.push($(this).text().trim());
                            }
                        }
                    }
                });
                if (!gInitialData.isDubai) {
                    $(thisInput).text(textArr.join(', '));
                }

            })
        }

        // Если нажали на иконку поиска
        if (event.target.closest('#index-search')) {
            $('.first-screen__btn-item').removeClass('active');
            $('.drop-body').removeClass('drop-show');
            return;
        }
        //

        if (event.target.closest('.tags__item-label') || event.target.closest('.checkbox-label')) {
            generateBtnInputValue($(event.target));
        }

        if ($(this).hasClass('active') && !event.target.closest('.filter__drop')) {
            $(this).removeClass('active');
            return;
        }
        $('.first-screen__btn-item').removeClass('active');
        $(this).addClass('active');
    });

    $(document).on('click', function(event) {
        if (!event.target.closest('.first-screen__btn')) {
            $('.first-screen__btn-item.active').removeClass('active');
        }
    });
}

export function mortgageSliders() {
    if ($('[data-slider]').length == 0) return;

    if ($('.complex-mortgage__sliders-item_fixed').length) {
        var fixedField = $('.complex-mortgage__sliders-item_fixed').find('.complex-mortgage__sliders-value span');
        fixedField.siblings('input[type="hidden"]').val(fixedField.text());
        fixedField.text(window.priceFormat(parseInt(fixedField.text())));
    }

    $('[data-slider]').each(function (index, thisSlider) {
        initSlider(thisSlider);
    });

    // функция инициализации слайдра
    function initSlider(sliderRange) {
        var sliderType = $(sliderRange).data('slider');

        var reCalcMortgage = function () {
            var cost = parseInt($('.complex-mortgage__cost').val().replace(/\s+/g, '')),
                initial = parseInt($('.complex-mortgage__initial').val().replace(/\s+/g, '')),
                years = parseInt($('.complex-mortgage__years').val().replace(/\s+/g, ''));

            var mortgagePayment = document.getElementById('mortgage-payment');

            if (mortgagePayment.noUiSlider !== undefined) {
                mortgagePayment.noUiSlider.updateOptions({
                    range: {
                        'min': 0,
                        'max': cost - 500000
                    }
                });
            }


            $('.complex-mortgage__banks-row').each(function () {
                var bankPercent = parseFloat($(this).find('[mortgage-percent]').text().replace(',', '.')),
                    paySize = gCalcMortgage(cost, initial, years, 0, bankPercent);
                $(this).find('[mortgage-payment]').html(paySize);
            });
        };

        // параметры
        var optionsMortgagePrice = {
            start: [58928382],
            connect: 'lower',
            range: {
                'min': 500000,
                'max': 200000000
            },
            format: {
                to: function (value) {
                    return parseInt(value);
                },
                from: function (value) {
                    return parseInt(value);
                }
            }
        };
        var optionsMortgagePayment = {
            start: [18000000],
            connect: 'lower',
            range: {
                'min': 0,
                'max': 199500000
            },
            format: {
                to: function (value) {
                    return parseInt(value);
                },
                from: function (value) {
                    return parseInt(value);
                }
            }
        };
        var optionsMortgageTerm = {
            start: [20],
            connect: 'lower',
            range: {
                'min': 1,
                'max': 30
            },
            format: {
                to: function (value) {
                    return parseInt(value);
                },
                from: function (value) {
                    return parseInt(value);
                }
            }
        };

        switch (sliderType) {
            case 'mortgage-price':
                noUiSlider.create(sliderRange, optionsMortgagePrice);
                sliderViewUpdate(optionsMortgagePrice.start);
                break;
            case 'mortgage-payment':
                noUiSlider.create(sliderRange, optionsMortgagePayment);
                sliderViewUpdate(optionsMortgagePayment.start);
                break;
            case 'mortgage-term':
                noUiSlider.create(sliderRange, optionsMortgageTerm);
                sliderViewUpdate(optionsMortgageTerm.start);
                break;
            default:
                return false;
        }

        sliderRange.noUiSlider.on('change', function (values) {
            sliderViewUpdate(values);
            reCalcMortgage();
        });

        // функция обновления
        function sliderViewUpdate(val) {
            var input = $(sliderRange).closest('[range-wrapp]').find('input');

            if (input.attr('type') == 'hidden') {
                var spanInput = $(input).siblings('span');
            }
            var currency = typeof $(input).data('unit') !== 'undefined';

            $(input).val(priceFormat(val, currency));
            $(input).attr('data-current-value', val);
            if (spanInput) {
                var unit = $(input).data('unit') != '' && currency ? `<span class="currency">${$(input).data('unit')}</span>` : false;
                var choices = typeof $(input).attr('data-choice-words') !== 'undefined' ? $(input).attr('data-choice-words') : false;
                if (choices) {
                    choices = choices.toString().split(',')
                    var word = transChoice($(input).val(), choices)
                    unit = $(input).attr('data-choice-words') != '' && currency ? `<span class="currency">${word}</span>` : false;
                }


                spanInput.html(`
                    ${$(input).val()} ${unit ? unit : ''}
                `)
            }
        }
    }

    // обрабатываем изменение инпутов
    $('[range-wrapp]').find('input, span[contenteditable="true"]').on('change focusout', function (event) {
        var wrapp = event.target.closest('[range-wrapp]');
        var slider_t = wrapp.querySelector('[data-slider]');

        switch (true) {
            case $(this).is('input'):
                var numValue = $(this).val().replace(/[^0-9]+/g, '');
                break;
            case $(this).is('span'):
                var numValue = $(this).text().replace(/[^0-9]+/g, '');
                $(this).siblings('input').val(trimSpace(numValue, true))
                break;
            default:
                return false;
        }

        numValue = trimSpace(numValue, true);

        if ($(this).attr('input-range') != '' && $(this).attr('input-range') != undefined) {
            switch ($(this).attr('input-range')) {
                case 'min':
                    slider_t.noUiSlider.set([numValue, null]);
                    break;
                case 'max':
                    slider_t.noUiSlider.set([null, numValue]);
                    break;
                default:
                    return false;
            }
        } else {
            slider_t.noUiSlider.set(numValue);
        }
    });

    // валидация вводимых данных в инпут
    $('[range-wrapp] input,span').on('keypress', function (event) {
        if (event.keyCode == 13) {
            $(this).blur();
        }
        numberValidate(event);
    });

    function gCalcMortgage(realtyPrice, initialPayment, years, bankInitialPayment, bankPercent) {
        var m = years * 12,
            vc = Math.min(initialPayment, realtyPrice),
            p12 = bankPercent / 1200,
            vr = Math.max(realtyPrice * bankInitialPayment, vc),
            sb = realtyPrice - vr;

        if (sb <= 0) {
            return '0';
        } else {
            var a = p12 * Math.pow((1 + p12), m) / (Math.pow((1 + p12), m) - 1);
            var vm = Math.round(a * sb);
            if (typeof (vm.toLocaleString) == 'undefined') {
                vm = gFormatPrice(vm);
            } else {
                vm = vm.toLocaleString();
            }
        }

        return vm;
    }

    if ($('.lots-main__mortgage-btn__price').length) {
        $('.lots-main__mortgage-btn__price').text($('[mortgage-payment]').first().text());
    }
}

export function mortgageShowMore() {
    if ($('.complex-mortgage__banks-more').length !== 0 && $('.complex-mortgage__drop-down').length !== 0) {
        var mortgageBtnMore = $('.complex-mortgage__banks-more'),
            mortgageDropDown = $('.complex-mortgage__drop-down'),
            titleBanksMore = {
                more: 'больше предложений',
                less: 'меньше предложений'
            },
            countClick = 0;

        mortgageBtnMore.click(function () {
            countClick++;

            if (countClick % 2 !== 0) {
                mortgageDropDown.slideDown(300);
                $(this).find('span').text(titleBanksMore.less);
            } else {
                mortgageDropDown.slideUp(300);
                $(this).find('span').text(titleBanksMore.more);
            }
        });
    }
}

    // Активация слайдера на мобильном
export function mobileSliderShow() {
    if (window.innerWidth < 768) {
        // Прячет обычные изображения
        $(document).find('.complex-list__images').each(function(index, item) {
            $(item).removeClass('show')
                .addClass('hidden')
                .addClass('transparent');
        });

        // Открывает слайдер на телефонах
        $(document).find('.complex-list__gallery-wrapp').each(function(index, item) {
            $(item).removeClass('hidden')
                .addClass('show');

            // Отключает автоматическое воиспроизведение видео при пролистывании слайдера
            var video = $(item).find('video')[0];

            // События клика по слайду с видео воиспроизведет/приостановит видео со звуком
            $(item).find('.complex-list__gallery-video-item').on('click', function() {
                var state = video.paused

                $(this).find('video').addClass('hide');
                $(this).find('iframe').addClass('show');
                $(this).closest('.complex-list__gallery-wrapp').next().addClass('hide');

                if (state) {
                    video.play();
                    video.muted = false;
                } else {
                    video.pause();
                    video.muted = true;
                }
            })
        })
    }
}

export function developerControll() {
    if ($('.developer-block__grid-item').length == 0) return;
    var heightGrid = $('.developer-block__grid-wrapp').height(),
        showTile = 5;

    if ($('.developer-block__grid-item').length <= showTile) {
        $('.developer-block__grid').removeClass('hidden');
        $('.developer-block__grid-item_btn').addClass('hidden');
        return;
    }

    $('.developer-block__grid-item').each(function (index, el) {
        if (!$(el).hasClass('developer-block__grid-item_btn') && index > showTile - 1) {
            $(el).addClass('hidden');
            $('.developer-block__grid').removeClass('hidden');
        }
        $('.developer-block__grid-item_btn').on('click', function (event) {
            $(this).addClass('animate-hidden');
            setTimeout(function () {
                $('.developer-block__grid-wrapp').animate({height: heightGrid}, 200);
            }, 500)
            setTimeout(function () {
                $('.developer-block__grid-item_dev.hidden').removeClass('hidden');
                $('.developer-block__grid-item_btn').removeClass('animate-hidden');
                $('.developer-block__grid-item_btn').addClass('hidden');
                fast_background.update();
            }, 700);
        });
    });
}

/**
 * flickitySlider()
 * для слайдера добавить атрибут data-slider-flickity
 * опции слайдера указываются так же через атрибуты
 * data-flickity-wrap-around="true"
 * data-flickity-contain="true"
 * data-flickity-cell-align="left"
 * data-flickity-set-gallery-size="true"
 * data-flickity-prev-next-buttons="true"
 * data-flickity-min-cell="6" - если количество элементов равно или меньше этого значения, то слайдер не инициализируется и к контейнеру добавляется класс slider-off.
 * data-flickity-only-desktop="true" - инициализация только для десктопа
 *
 * data-flickity-dots-carousel - Для буллетов с активным элементом, который становится шире остальных. Добавить атрибут и указать в нём класс контейнера для них. К буллетам будет применен flickity и они будут двигаться вместе с основным слайдером.
 *
 * для кастомных кнопок вперед и назад добавить атрибуты
 * data-flickity-next
 * data-flickity-prev
 * а так же для общего контейнера слайдера, кнопок и буллетов добавить атрибут data-wrapp-flickity. Иначе кнопки и буллеты не будут работать.
 */
export function flickitySlider() {
    $('[data-slider-flickity]').each(function () {
        let slider = $(this);
        let wrapp = slider.closest('[data-wrapp-flickity]');

        if (slider.data('flickity-only-desktop') == true && $(window).width() < 768) {
            return;
        }

        if (slider.children().length <= slider.data('flickity-min-cell')) {
            slider.addClass('slider-off');
            return;
        }

        slider.flickity({
            pageDots: false,
            prevNextButtons: $(slider).data('flickity-prev-next-buttons') ? true : false,
            contain: $(slider).data('flickity-contain') ? true : false,
            wrapAround: $(slider).data('flickity-wrap-around') ? true : false,
            cellAlign: $(slider).data('flickity-cell-align') ? $(slider).data('flickity-cell-align') : 'left',
            setGallerySize: $(slider).data('flickity-set-gallery-size') ? true : false,
        });

        if (wrapp && wrapp.length > 0) {
            let prev = wrapp.find('[data-flickity-prev]');
            let next = wrapp.find('[data-flickity-next]');

            if (prev.length > 0 && next.length > 0) {
                prev.on('click', function () {
                    slider.flickity('previous');
                })

                next.on('click', function () {
                    slider.flickity('next');
                })
            }

            if ($(slider).data('flickity-dots-carousel')) {
                let dotsSlider = wrapp.find(`.${$(slider).data('flickity-dots-carousel')}`);
                let dotTemplate = '<div class="flickity-dot"><span></span></div>';

                slider.data('flickity').slides.forEach(element => {
                    dotsSlider.append(dotTemplate);
                });

                dotsSlider.flickity({
                    pageDots: false,
                    prevNextButtons: false,
                    contain: true,
                    wrapAround: $(slider).data('flickity-wrap-around') ? true : false,
                    cellAlign: 'center',
                    percentPosition: true,
                });

                slider.on('select.flickity', function (e, i) {
                    dotsSlider.flickity('select', i);
                });
            }
        }
    })
}

export function articleDropdown() {
    $('.article-dropdown__bottom button').click(function() {
        toggleArticleDropdown($(this));
    });

    function toggleArticleDropdown(target) {
        if ($(window).width() < 768) {
            var body = $(target).closest('.article-dropdown').find('.article-dropdown__wrapp');
        } else {
            var body = $(target).closest('.article-dropdown').find('.article-dropdown__body');
        }
        var buttons = $(target).closest('.article-dropdown').find('.article-dropdown__bottom button');
        buttons.toggle();
        body.slideToggle(300);
    }
};
